<!-- <div class="row m-4">
   <div class="col-md-3">
    <app-navbar
    (send_selected_from_search_dialog)="recieve_selected_multiple_items($event)"
    [allowMultipleSelect] = "true"></app-navbar>
  </div>
   <div class="col-md-4">
       <h1><i class="fa fa-arrow-circle-up text-danger mr-1"></i> System Software <strong>Manager </strong>
    </h1>
  </div>
</div> -->

<mat-slide-toggle [(ngModel)]="switcher_toggle_navigator"> Toggle Navigator</mat-slide-toggle>
<div class="row p-4">
  <!--  Navigator-->
  <div class="col-md-5" [hidden]="!switcher_toggle_navigator">
    <div  class="m-4" >
      <form>
        <mat-form-field appearance="fill">
          <mat-label>Sort tree by</mat-label>
          <mat-select [(ngModel)]="sort_tree_by" name="item">
            <mat-option *ngFor="let item of sort_by_list" [value]="item.value">
              {{item.viewValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        </form>
      <app-treeview-systems
        parent_icon="folder"
        child_icon="videocam"
        parent_table_name="ngaccessmanagement_ngfoldertree"
        parent_table_pk="id"
        parent_table_ref_value="item_name"
        child_table_name="ngaccessmanagement_ngsystemprofile"
        child_table_displayname="system_name"
        child_table_fk="folder_id_id"
        algorithm="m2mtable"
        title="Location"
        [sort_by] = sort_tree_by
        (messageSelectedMultipleNodes)="recieve_selected_multiple_items($event)"
      ></app-treeview-systems>
    </div>
  </div>
  <div class="login-clean m-auto" [hidden]="!switcher_toggle_navigator">
    <button mat-raised-button color="primary" style="width: 4em; height : 20em;" [disabled]="recieve_selected_items.length == 0" (click)="move_selected_to_list()">
      <mat-icon>arrow_forward_ios</mat-icon>
    </button>
  </div>
  <div

    [ngClass]="{'col-md-6 shadow m-4 ':show_job_form==true || switcher_toggle_navigator==true,'col-md-12 m-4 ':switcher_toggle_navigator==false&& show_job_form==false}">
    <form [formGroup]="form_updatelist">
      <mat-list>
        <div class="m-3 ">
          <mat-chip-list>
            <h3><i class="fa fa-list-alt mr-1 text-danger"></i> Upgrade list
              <mat-chip  class="text-sm-center">{{upgrade_list.length}}</mat-chip>
              <button [disabled]="upgrade_list.length == 0" class="ml-4" color="primary" mat-button type="button"
                      (click)="upgrade_list=[];form_updatelist.reset()">Clear list
              </button>
              <button [disabled]="upgrade_list.length == 0 || !form_updatelist.get('start_at').value " class="ml-4" color="primary" mat-button type="button"
                      (click)="create_job()">Create a job
              </button>

            </h3>
          </mat-chip-list>
          <h5>1. <i class="fa fa-clock text-danger mr-1"></i> Select Start Date/Time <input mat-input formControlName="start_at" id="job_start_time" value="dt1.selected" [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" placeholder="Date Time">
            <owl-date-time #dt1></owl-date-time>
          </h5>

          <h5>2. <i class="fa fa-check text-danger mr-1"></i> select the required package to upgrade</h5>
          <mat-divider></mat-divider>

        </div>
        <div style="overflow: scroll;height: 50vh;  scrollbar-width: thin;">

          <mat-list-item [ngClass]="{'text-danger':record['package'].length ==0}" *ngFor="let record of upgrade_list">
            <mat-icon mat-list-icon>videocam</mat-icon>
            <div mat-line>{{record["system"]["system_name"]}}</div>
            <div mat-line>System IP: {{record["system"]["system_ip"]}}</div>
            <div mat-line>Product ID: {{record["system"]["product_id"]}}</div>
            <div mat-line>Software Name: {{record["system"]["software_name"]}}</div>
            <div mat-line>Software Version: {{record["system"]["software_version"]}}</div>
            <!--            hidden values for the form-->
<!--            <input type="hidden" [formControlName]="'system_name_'+record['system']['id']">-->
<!--            <input type="hidden" [formControlName]="'system_ip_'+record['system']['id']">-->
<!--            <input type="hidden" [formControlName]="'operation_name_'+record['system']['id']">-->
<!--            <input type="hidden" [formControlName]="'job_status_'+record['system']['id']">-->
<!--            <input type="hidden" [formControlName]="'is_executed_'+record['system']['id']" value="1">-->
            <!--            end-->
            <div class="mr-2">
              <button mat-raised-button color="primary" [id]="'value_'+record['system']['id']" hidden (click)="change_all_similar('value_'+record['system']['id'])">
                Apply to Similar
              </button>
            </div>
            <div *ngIf="record['package'].length ==0;else software_menu">
              <h5><i class="fa fa-times-circle text-danger mr-1"></i> No compatible package found for this software
                family {{record["system"]["software_name"]}} </h5>
            </div>
            <ng-template #software_menu>


              <mat-form-field class="mr-2">
                <mat-label>Available Package/s</mat-label>
                <mat-select [formControlName]="'value_'+record['system']['id']" [ngModel]="record['package'][0].file_path" (selectionChange)='changed_selected_option($event.value,record["system"]["software_name"],record["system"]["id"])'>
                  <mat-option *ngFor="let row_package of record['package']" [value]="row_package.file_path"
                              >
                    {{row_package['file_name']}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
            <i class="fa fa-trash-alt fa-pull-right" (click)="delete_item_from_array(record['system'])"></i>
            <mat-divider></mat-divider>
          </mat-list-item>

        </div>

      </mat-list>
    </form>
  </div>
  <div [hidden]="!show_job_form || switcher_toggle_navigator"
       [ngClass]="{'col-md-6':show_job_form==true&&switcher_toggle_navigator==false,'col-md-12':show_job_form==false}">
    <h1>Job Profile</h1>
    <hr>
  </div>
</div>

